<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4"
  (click)="onClose()">
  <div
    class="bg-white dark:bg-slate-900 w-full max-w-3xl rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()">

    <div
      class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 bg-amber-50/40 dark:bg-amber-900/10 flex items-start justify-between gap-3">
      <div class="flex items-start gap-3 min-w-0">
        <div class="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
          <span class="material-icons text-[20px]">functions</span>
        </div>
        <div class="min-w-0">
          <h3 class="text-lg font-black text-slate-900 dark:text-white truncate">
            {{ isEdit ? 'แก้ไข Sub Rate' : 'เพิ่ม Sub Rate' }}
          </h3>
          <p class="text-xs text-slate-400 mt-1">อัตราย่อย · parking_sub_rate</p>
        </div>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-white dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer flex items-center justify-center shrink-0">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 overflow-y-auto custom-scrollbar space-y-5" *ngIf="!isLoading(); else loadingTpl">
      <!-- Basic -->
      <section>
        <div class="flex items-center gap-2 mb-3">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">1</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">ข้อมูลหลัก</h4>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">
              Rate ID <span class="text-rose-500">*</span>
            </label>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-800/40 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[18px]">tag</span>
              <input type="text" [(ngModel)]="formData.rateId" placeholder="เช่น SUB001"
                class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-semibold text-slate-700 dark:text-slate-200 focus:outline-none" />
            </div>
          </div>
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">
              ชื่อ <span class="text-rose-500">*</span>
            </label>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-800/40 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[18px]">label</span>
              <input type="text" [(ngModel)]="formData.name" placeholder="ชื่ออัตราย่อย"
                class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-semibold text-slate-700 dark:text-slate-200 focus:outline-none" />
            </div>
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Rate Type</label>
            <input type="text" [(ngModel)]="formData.rateType" placeholder="ประเภท"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Sub Free Time Y/N</label>
            <input type="text" [(ngModel)]="formData.subFreeTimeYn" placeholder="Y / N"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
      </section>

      <!-- Time -->
      <section>
        <div class="flex items-center gap-2 mb-3">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">2</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">เวลา</h4>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Min Free Time</label>
            <input type="number" [(ngModel)]="formData.minFreeTime" placeholder="นาที"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Min Round</label>
            <input type="number" [(ngModel)]="formData.minRound"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Cut Time</label>
            <input type="text" [(ngModel)]="formData.cutTime" placeholder="เช่น 00:00"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Hour Over Flat</label>
            <input type="number" [(ngModel)]="formData.hourOverFlat"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Time Period Free</label>
            <input type="text" [(ngModel)]="formData.timePeriodFree" placeholder="ช่วงเวลาไม่คิดค่าจอด"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
      </section>

      <!-- Pricing -->
      <section>
        <div class="flex items-center gap-2 mb-3">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">3</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">ราคา</h4>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Price Per Hour</label>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-800/40 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[18px]">payments</span>
              <input type="number" [(ngModel)]="formData.pricePerHour" placeholder="0"
                class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-semibold text-slate-700 dark:text-slate-200 focus:outline-none" />
            </div>
          </div>
          <div class="space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Price Flat</label>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-800/40 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[18px]">sell</span>
              <input type="number" [(ngModel)]="formData.priceFlat" placeholder="0"
                class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-semibold text-slate-700 dark:text-slate-200 focus:outline-none" />
            </div>
          </div>
        </div>
      </section>

      <!-- Format -->
      <section>
        <div class="flex items-center gap-2 mb-3">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">4</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">รูปแบบ / หมายเหตุ</h4>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Format</label>
            <textarea [(ngModel)]="formData.format" rows="6" placeholder="รูปแบบการคิดราคา (พิมพ์ยาวได้)"
              class="w-full min-h-[140px] px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-mono font-medium outline-none focus:ring-2 focus:ring-amber-200 resize-y leading-relaxed"></textarea>
          </div>
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Service Charge Format</label>
            <input type="text" [(ngModel)]="formData.serviceChargeFormat" placeholder="รูปแบบค่าบริการเพิ่มเติม"
              class="w-full h-[46px] px-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="md:col-span-2 space-y-1.5">
            <label class="text-xs font-bold text-slate-500">Comment</label>
            <textarea [(ngModel)]="formData.comment" rows="2" placeholder="หมายเหตุ (ถ้ามี)"
              class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
          </div>
        </div>
      </section>
    </div>

    <ng-template #loadingTpl>
      <div class="p-14 flex flex-col items-center justify-center text-slate-400 gap-2">
        <span class="material-icons text-3xl opacity-40 animate-pulse">hourglass_top</span>
        <p class="text-sm font-medium">กำลังโหลด...</p>
      </div>
    </ng-template>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3 bg-slate-50/60 dark:bg-slate-900/40">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 shrink-0 bg-white dark:bg-slate-800">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 flex-1 justify-end">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 cursor-pointer bg-white dark:bg-slate-800 disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50 shadow-md shadow-amber-200/40 dark:shadow-none">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingSubRate"
  [entityId]="itemId"
  title="ประวัติอัตราย่อย"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
